import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { submitKeysOf } from '../components/workflow/useWorkflowPerms';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import { JoinedNamesCell } from '../components/workflow/CoverageDisplay';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import { formatDateShort } from '../utils/dateFormat';

// QC35 Form submissions — list page (docs/modules/workflow-qc35.md; separate from
// Signed Financial Statements).
const WorkflowQc35 = () => {
  const { hasPermission } = useAuth();
  return (
    <WorkflowListShell
      title="QC35 Form"
      subtitle="QC35 Form file archival submissions."
      newTo="/workflow/qc35/new"
      canCreate={submitKeysOf('qc35').some(hasPermission)}
      apiPath="/api/workflow/qc35"
      searchPlaceholder="Search submission / engagement / requester…"
      width="mid"
      rowTo={(r) => `/workflow/qc35/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Submission',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/qc35/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'engagement', label: 'Engagement', sortKey: 'engagement', className: 'text-slate-900', render: (r) => <JoinedNamesCell value={r.engagementNames} fallback={r.engagementName} now={r.engagementNamesNow || r.engagementNameNow} serviceDescription={r.firstServiceDescription} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'requester', label: 'Requester', sortKey: 'requester', className: 'text-slate-600', render: (r) => r.requesterEmail },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowQc35;
